import Toastify from 'toastify-js'

const config = {
    gravity: 'top',
    position: 'center',
    escapeMarkup: false,
    stopOnFocus: true,
    duration: 1600,
    offset: {
        y: '3.618rem',
    },
}

const notifications = {
    /**
     * Displays a success notification/top bar with the text value provided, fades out automatically.
     * @param {string} message The text to display
     */
    success(message) {
        const text = `
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M40.3166 12.6953C40.8991 13.2844 40.8937 14.2342 40.3046 14.8166L18.0547 36.8166C17.4736 37.3912 16.5396 37.3949 15.954 36.8251L6.70397 27.8251C6.11021 27.2474 6.0972 26.2977 6.67491 25.704C7.25262 25.1102 8.20228 25.0972 8.79603 25.6749L16.9915 33.6489L38.1953 12.6834C38.7844 12.1009 39.7342 12.1063 40.3166 12.6953Z" fill="var(--md-background)"/>
            </svg>
            <span>${message}</span>
        `

        Toastify({
            text,
            ...config,
            className: 'success',
        }).showToast()
    },

    /**
     * Displays an error notification/top bar with the text value provided, fades out automatically.
     * @param {string} message The text to display
     */
    error(message) {
        const text = `
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10.909 2.782a2.25 2.25 0 0 1 2.975.74l.083.138 7.759 14.009a2.25 2.25 0 0 1-1.814 3.334l-.154.006H4.242A2.25 2.25 0 0 1 2.2 17.812l.072-.143L10.03 3.66a2.25 2.25 0 0 1 .879-.878ZM12 16.002a.999.999 0 1 0 0 1.997.999.999 0 0 0 0-1.997Zm-.002-8.004a1 1 0 0 0-.993.884L11 8.998 11 14l.007.117a1 1 0 0 0 1.987 0l.006-.117L13 8.998l-.007-.117a1 1 0 0 0-.994-.883Z" fill="var(--md-background)"/></svg>
            <span>${message}</span>`

        Toastify({
            text,
            ...config,
            className: 'error',
        }).showToast()
    },
}

export default notifications